// Single source of truth for user-facing UI strings.
// Finnish (fi) is the default and MUST keep its exact current wording.
// en / de are provided for the upcoming bilingual work (parts 2-4).
export const TRANSLATIONS = {
  fi: {
    // ---- common ----
    "common.loading": "Ladataan…",
    "common.notFound": "Ei löytynyt",
    "common.linkCopied": "Linkki kopioitu",
    "common.emailPlaceholder": "sinun@sahkoposti.fi",
    "common.sending": "Lähetetään…",
    "common.creating": "Luodaan…",
    "common.saving": "Tallennetaan…",
    "common.saveFailed": "Tallennus epäonnistui",
    "common.deleteFailed": "Poisto epäonnistui",
    "common.cancel": "Peruuta",
    "common.save": "Tallenna",
    "common.copy": "Kopioi",
    "common.copied": "Kopioitu",
    "common.send": "Lähetä",
    "common.contact": "Yhteydenotot:",

    // ---- nav / footer ----
    "nav.occasions": "Tilaisuudet",
    "footer.privacy": "Tietosuoja",
    "footer.terms": "Käyttöehdot",
    "footer.legal": "Palvelun tarjoaa {name} (CIF {cif}), {address}. Yhteydenotot: {email}",
    "footer.legalPre": "Palvelun tarjoaa {name} (CIF {cif}), {address}. Yhteydenotot:",

    // ---- report dialog ----
    "report.trigger": "Ilmoita väärinkäytöstä tai pyydä vastauksesi poistoa",
    "report.title": "Ilmoita väärinkäytöstä tai pyydä poistoa",
    "report.desc": "Kerro lyhyesti, mistä on kyse. Otamme sinuun yhteyttä antamaasi osoitteeseen.",
    "report.confirmation": "Ilmoitus vastaanotettu. Kiitos!",
    "report.messageLabel": "Viesti",
    "report.messagePlaceholder": "Kuvaile tilanne…",
    "report.emailLabel": "Sähköpostisi",
    "report.submit": "Lähetä ilmoitus",
    "report.err.fill": "Täytä viesti ja sähköposti",
    "report.err.failed": "Lähetys epäonnistui, yritä uudelleen",

    // ---- home ----
    "home.recover.trigger": "Kadotitko admin-linkin?",
    "home.recover.title": "Kadotitko admin-linkin?",
    "home.recover.desc": "Anna sähköpostiosoite, jolla loit keräyksen. Lähetämme admin-linkit siihen.",
    "home.recover.submit": "Lähetä linkit",
    "home.freeBanner": "Tämä muotokuva on ilmainen (arvo 29 EUR). Hinta sisältää sekä muotokuvan että e-kirjan. Linkki on käytettävä {date} mennessä.",
    "home.hero.title": "Lämmin lahja ystäviltä",
    "home.hero.subtitle": "Kokoa ystävien ja läheisten vastaukset yhdeksi kirjoitetuksi muotokuvaksi. Kerää muistoja ja terveisiä omalla linkillä, ja anna tekoälyn kutoa niistä yhtenäinen kertomus, jonka voi lukea ääneen tai antaa lahjaksi.",
    "home.sample.eyebrow": "Esimerkki valmiista muotokuvasta",
    "home.sample.text": "Aino on ihminen, jonka läsnäolo huomataan vasta kun hän poistuu huoneesta – silloin nauru hiljenee hetkeksi. Ystävät muistavat hänen keittiönsä: aina liian pieni, aina täynnä väkeä, ja pöydällä se sama nokkoskeitto, jota kukaan ei osannut odottaa rakastavansa. Hän kysyy kysymyksiä, joita muut eivät kehtaa, ja jää sitten kuuntelemaan vastauksen loppuun asti. Moni kertoo samasta illasta: junat oli peruttu, ilma harmaa, ja Aino ilmestyi asemalle termospullon ja kahden villasukan kanssa, ikään kuin olisi tiennyt. Opiskeluaikoina hän piti kokonaisen kämppäkunnan pystyssä listoilla, muistilapuilla ja itse leipomallaan pullalla, eikä koskaan laskenut, kuka oli velkaa kenellekin. Hän ei koskaan tee numeroa hyvyydestään. Hän vain soittaa oikealla hetkellä, muistaa pienet päivämäärät ja uskoo sinuun hieman lujemmin kuin sinä itse. Hänen kanssaan tavallisesta tiistaista tulee jotakin, jonka muistaa vielä vuosien päästä. Nyt on meidän vuoromme muistaa hänet – ei täydellisenä, vaan juuri sellaisena lämpimänä, itsepäisenä ja rakastettuna kuin hän on.",
    "home.sample.note": "Saat kirjoitetun muotokuvan tekstinä - ei kuvaa tai piirrosta.",
    "home.form.subjectPerson": "Kenelle lahja tehdään?",
    "home.form.subjectCommunity": "Muotokuvan kohde",
    "home.form.namePlaceholderPerson": "Sankarin nimi, esim. Maija",
    "home.form.namePlaceholderCommunity": "esim. ryhmän tai yhteisön nimi",
    "home.form.giver": "Sinun nimesi",
    "home.form.giverPlaceholder": "Järjestäjän nimi, esim. Ville",
    "home.form.email": "Sähköpostisi",
    "home.form.emailHelp": "Lähetämme linkit tähän osoitteeseen. Admin-linkki on ainoa pääsy keräykseen, joten säilytä viesti.",
    "home.form.occasion": "Tilaisuus",
    "home.form.occasionPlaceholder": "esim. Syntymäpäivä, Eläkejuhla, Häät",
    "home.form.description": "Kuvaus (vapaaehtoinen)",
    "home.form.descriptionPlaceholder": "Lyhyt kuvaus tilaisuudesta",
    "home.form.questions": "Kysymykset ({n}/10)",
    "home.form.nimiHintPre": "Vinkki:",
    "home.form.nimiHintPost": "korvataan automaattisesti muotokuvan kohteen nimellä.",
    "home.form.questionPlaceholder": "Kirjoita kysymys…",
    "home.form.nimiWarnPre": "Vältä taivutuspäätettä nimen perässä. Kirjoita kysymys niin, että",
    "home.form.nimiWarnPost": "on perusmuodossa.",
    "home.form.addQuestion": "Lisää kysymys",
    "home.form.closesAt": "Viimeinen vastauspäivä",
    "home.form.closesHelp": "Keräys sulkeutuu tämän päivän lopussa. Enintään 30 päivää.",
    "home.form.submit": "Luo keräys",
    "home.usedFor": "Mihin tätä on käytetty",
    "home.success.title": "Keräys {name} on valmis!",
    "home.success.title.fb": "Keräys on valmis! ({name})",
    "nameForms.genitiveLabel": "Kenen muotokuva?",
    "nameForms.genitiveHelp": "Tarkista, että nimi on taivutettu oikein. Tätä muotoa käytetään sähköposteissa ja kirjassa.",
    "nameForms.genitivePreview": "{name} muotokuva",
    "nameForms.genitivePreviewFb": "Muotokuva: {name}",
    "nameForms.allativeLabel": "Kenelle lahja tehdään?",
    "nameForms.allativeHelp": "Tarkista taivutus. Tätä muotoa käytetään otsikoissa ja sähköposteissa.",
    "nameForms.allativePreview": "Keräys {name}",
    "nameForms.allativePreviewFb": "Keräys: {name}",
    "nameForms.generating": "Haetaan taivutusmuotoja…",
    "nameForms.sectionTitle": "Nimen taivutus",
    "nameForms.sectionHelp": "Näitä muotoja käytetään sähköposteissa ja otsikoissa. Muutokset vaikuttavat jatkossa lähetettäviin viesteihin ja luotaviin dokumentteihin.",
    "nameForms.save": "Tallenna nimimuodot",
    "nameForms.saved": "Nimimuodot tallennettu",
    "nameForms.saveFailed": "Tallennus epäonnistui",
    "home.success.subtitle": "Jaa alla oleva vastauslinkki ystäville.",
    "home.success.emailSent": "Linkit on lähetetty myös osoitteeseen {email}",
    "home.success.emailFailed": "Linkkien lähetys osoitteeseen {email} ei onnistunut – tallenna linkit alta.",
    "home.success.publicLabel": "Vastauslinkki ystäville",
    "home.success.publicHint": "Jaa tämä kaikille, jotka haluat mukaan lahjaan.",
    "home.success.adminLabel": "Oma hallintalinkkisi",
    "home.success.adminHint": "Tästä näet vastaukset ja luot muotokuvan.",
    "home.success.warnStrong": "Tallenna hallintalinkki nyt.",
    "home.success.warnRest": "Se on ainoa tapa päästä vastauksiin, eikä sitä voi palauttaa jälkeenpäin.",
    "home.success.goAdmin": "Siirry hallintaan",
    "home.err.bothNames": "Täytä molemmat nimet",
    "home.err.email": "Anna sähköpostiosoitteesi",
    "home.err.occasionName": "Anna tilaisuudelle nimi",
    "home.err.atLeastOneQuestion": "Lisää vähintään yksi kysymys",
    "home.err.createFailed": "Keräyksen luonti epäonnistui",
    "home.err.recoverEmail": "Anna sähköpostiosoite",
    "home.err.recoverFailed": "Jotain meni pieleen, yritä uudelleen",

    // ---- answer ----
    "answer.submit": "Lähetä vastaus",
    "answer.submitting": "Tallennetaan…",
    "answer.next": "Seuraava",
    "answer.prev": "Edellinen",
    "answer.saveDraft": "Jatka myöhemmin",
    "answer.progress": "Kysymys {n}/{total}",
    "answer.placeholder": "Kirjoita vastauksesi tähän…",
    "answer.emailHelp": "Käytämme sitä vain, jos haluat poistaa vastauksesi myöhemmin.",
    "answer.draftRestored": "Palautettiin aiemmin tallennettu luonnos.",
    "answer.draftSaved": "Luonnos tallennettu tälle laitteelle. Voit jatkaa myöhemmin samasta linkistä.",
    "answer.err.atLeastOne": "Vastaa vähintään yhteen kysymykseen",
    "answer.err.nameOrAnon": "Kirjoita nimesi tai valitse nimettömänä vastaaminen",
    "answer.err.submitFailed": "Tallennus epäonnistui",
    "answer.notFound.title": "Keräystä ei löytynyt",
    "answer.notFound.body": "Tarkista linkki ja yritä uudelleen.",
    "answer.closed.title": "Keräys on suljettu, kiitos!",
    "answer.closed.body": "Vastauksia ei enää oteta vastaan.",
    "answer.headingCommunity": "Muotokuva: {name}",
    "answer.headingPerson": "Syntymäpäivälahja {name}",
    "answer.headingPerson.fb": "Syntymäpäivälahja: {name}",
    "answer.intro": "Kokoamme {name} lahjaa: {occasion}. Vastaa muutamaan kysymykseen, se vie noin kaksi minuuttia. Vastaukset tiivistetään tekoälyn avulla yhdeksi muotokuvaksi. Kukaan ei näe yksittäisiä vastauksia ilman lupaasi, ja ne poistetaan juhlien jälkeen.",
    "answer.intro.fb": "Kokoamme lahjaa ({name}): {occasion}. Vastaa muutamaan kysymykseen, se vie noin kaksi minuuttia. Vastaukset tiivistetään tekoälyn avulla yhdeksi muotokuvaksi. Kukaan ei näe yksittäisiä vastauksia ilman lupaasi, ja ne poistetaan juhlien jälkeen.",
    "answer.deadline": "Vastausaikaa on {date} asti.",
    "answer.privacyLink": "Lue tietosuojaseloste",
    "answer.bookNotice": "Vastauksesi yhdistetään yhdeksi lyhyeksi muotokuvaksi, ja kaikki kirjoittamasi tulostetaan lisäksi kokonaisuudessaan omalle sivullesi kirjaan.",
    "answer.liveCounter": "{n} ihmistä on vastannut.",
    "answer.nameLabel": "Nimi",
    "answer.namePlaceholder": "Etunimesi",
    "answer.anonLabel": "Vastaan nimettömänä",
    "answer.emailLabel": "Sähköpostisi (vapaaehtoinen)",
    "answer.langFi": "Suomeksi",
    "answer.langDe": "Auf Deutsch",

    // ---- thank you ----
    "thankyou.heading": "Kiitos!",
    "thankyou.saved": "Vastauksesi on tallennettu.",
    "thankyou.ctaTitle": "Haluatko tehdä tällaisen muotokuvan jollekulle itse?",
    "thankyou.ctaButton": "Tee oma muotokuva",
    "thankyou.leadConfirmation": "Kiitos! Olet listalla.",
    "thankyou.leadLabel": "Jätä sähköpostisi, niin kerron uusista tilaisuuksista ja ominaisuuksista",
    "thankyou.privacy": "Tietosuoja",
    "thankyou.err.emailEmpty": "Syötä sähköpostiosoite",
    "thankyou.err.saveFailed": "Tallennus epäonnistui, tarkista osoite",

    // ---- celebration ----
    "celebration.notReady.title": "Lahja ei ole vielä valmis",
    "celebration.notReady.body": "Palaa hetken kuluttua uudelleen.",
    "celebration.readAll": "Lue kaikkien vastaukset",
    "celebration.downloadBook": "Lataa kirja (PDF)",

    // ---- removal ----
    "removal.deleted": "Vastauksesi on poistettu",
    "removal.notFound": "Vastausta ei löytynyt",
    "removal.deletedBody": "Kiitos. Vastauksesi on poistettu pysyvästi tietokannasta.",
    "removal.notFoundBody": "Vastaus on saatettu jo poistaa, tai linkki on vanhentunut.",
    "removal.title": "Poista vastauksesi",
    "removal.confirmBody": "Haluatko poistaa vastauksesi keräyksestä {name}? Poisto on pysyvä eikä sitä voi perua.",
    "removal.button": "Poista vastaukseni",
    "removal.deleting": "Poistetaan…",
    "removal.success": "Vastauksesi on poistettu",

    // ---- privacy page ----
    "privacy.title": "Tietosuoja",
    "privacy.tradingAs": "(aputoiminimi Portwrite)",
    "privacy.registrar": "Palvelun tarjoaa ja rekisterinpitäjänä toimii Sunbnb España SL, joka tarjoaa palvelua nimellä Portwrite.",

    // ---- terms page ----
    "terms.title": "Käyttöehdot",
    "terms.provider": "Palveluntarjoaja",
    "terms.serviceTitle": "Palvelun kuvaus",
    "terms.serviceBodyPre": "Portwrite kokoaa ystävien ja läheisten vastaukset yhdeksi tekoälyn kirjoittamaksi muotokuvaksi. Muotokuva on",
    "terms.serviceBodyStrong": "kirjoitettua tekstiä",
    "terms.serviceBodyPost": "– ei kuvaa tai piirrosta – ja se toimitetaan tekstinä sekä ladattavana e-kirjana (PDF) ja verkkoversiona.",
    "terms.priceTitle": "Hinta ja maksaminen",
    "terms.priceBody": "Vastausten kerääminen ja muotokuvan luominen on maksutonta. Valmiin muotokuvan ja e-kirjan avaaminen maksaa kuluttajalle 29 € (sisältää arvonlisäveron). Maksu suoritetaan turvallisesti Stripen kautta. Voit halutessasi antaa yrityksen nimen ja ALV-tunnuksen laskutusta varten; se ei muuta hintaa.",
    "terms.deliveryTitle": "Toimitus",
    "terms.deliveryPre": "Muotokuva ja e-kirja avataan ja toimitetaan",
    "terms.deliveryStrong": "heti maksun jälkeen",
    "terms.deliveryPost": "hallintasivulle, ja ostaja saa vahvistuksen sähköpostitse.",
    "terms.withdrawalTitle": "Peruuttamisoikeus",
    "terms.withdrawalPre": "Kyseessä on digitaalinen sisältö, joka toimitetaan sähköisesti. Ostaja hyväksyy maksun yhteydessä, että toimitus alkaa välittömästi.",
    "terms.withdrawalStrong": "14 päivän peruuttamisoikeus raukeaa, kun toimitus on alkanut ostajan nimenomaisella suostumuksella.",
    "terms.withdrawalPost": "Suostumus tallennetaan tilaustietoihin aikaleiman kanssa.",
    "terms.liabilityTitle": "Vastuunrajoitus",
    "terms.liabilityBody": "Palvelu tarjotaan sellaisenaan. Muotokuvan tekstin tuottaa tekoäly osallistujien vastausten pohjalta, eikä palveluntarjoaja vastaa sisällön täydellisestä tarkkuudesta tai sopivuudesta tiettyyn tarkoitukseen. Palveluntarjoajan vastuu rajoittuu enintään palvelusta maksettuun summaan.",
    "terms.lawTitle": "Sovellettava laki ja riitojen ratkaisu",
    "terms.lawPre": "Näihin käyttöehtoihin sovelletaan Espanjan lakia. Kuluttajalla voi olla oikeus saattaa riita kuluttajariitoja käsittelevän elimen ratkaistavaksi. Erimielisyydet pyritään ensisijaisesti ratkaisemaan sopimalla ottamalla yhteyttä osoitteeseen",

    // ---- occasions page ----
    "occasions.title": "Tilaisuudet",
    "occasions.subtitle": "Valmiita pohjia muotokuvan kokoamiseen. Valitse pohja tai luo aivan oma.",
    "occasions.templateBadge": "Pohja",
    "occasions.usage": "Käytetty {n} kertaa",
    "occasions.use": "Käytä tätä pohjana",
    "occasions.createOwn": "Luo oma tilaisuus",

    // ---- free link page ----
    "free.used": "Tämä ilmainen linkki on jo käytetty.",
    "free.expired": "Tämä ilmainen linkki on vanhentunut.",
    "free.invalid": "Linkkiä ei löytynyt.",
    "free.stillCreate": "Voit silti luoda tavallisen muotokuvan. Vastausten kerääminen on maksutonta.",
    "free.startNormal": "Luo tavallinen muotokuva",

    // ---- purchase section ----
    "purchase.previewEyebrow": "Esikatselu",
    "purchase.previewTitle": "Näin lahja näyttää",
    "purchase.previewSubtitle": "Näet alla alun. Koko muotokuva ja e-kirja avautuvat oston jälkeen.",
    "purchase.questionsTitle": "Kysymykset",
    "purchase.morePages": "…ja {n} sivua lisää",
    "purchase.totalPages": "Yhteensä {n} sivua",
    "purchase.sellerPre": "Myyjä:",
    "purchase.sellerTradingAs": "(aputoiminimi Portwrite), CIF {cif}. Yhteydenotot:",
    "purchase.includesPortrait": "Muotokuva & e-kirja (PDF)",
    "purchase.includesWeb": "Web-versio",
    "purchase.buy": "Osta",
    "purchase.redirecting": "Siirrytään maksuun…",
    "purchase.consentMain": "Hyväksyn, että muotokuva toimitetaan heti maksun jälkeen, ja ymmärrän menettäväni 14 päivän peruuttamisoikeuden, kun toimitus on alkanut.",
    "purchase.consentAcceptPre": "Hyväksyn myös",
    "purchase.consentTerms": "käyttöehdot",
    "purchase.consentAnd": "ja",
    "purchase.consentPrivacy": "tietosuojaselosteen",
    "purchase.companyNote": "Voit halutessasi lisätä yrityksen nimen ja ALV-tunnuksen maksun yhteydessä laskutusta varten. Se ei muuta hintaa.",
    "purchase.companyToggle": "Ostan yrityksenä (EU-ALV-numero)",
    "purchase.vatLabel": "EU-ALV-numero",
    "purchase.vatPlaceholder": "esim. FI12345678",
    "purchase.vatChecking": "Tarkistetaan ALV-numeroa…",
    "purchase.vatValid": "ALV-numero vahvistettu. Osto tehdään käännetyllä verovelvollisuudella hintaan {price} € (ei IVA:a). Saat PDF-laskun.",
    "purchase.vatInvalid": "ALV-numeroa ei voitu vahvistaa. Osto tehdään tavallisena kuluttajaostoksena hintaan 29 € (sisältää Espanjan IVA 21 %). Voit yrittää uudelleen kelvollisella EU-ALV-numerolla, jos tarvitset laskun käännetyllä verovelvollisuudella.",
    "purchase.vatRequired": "Syötä EU-ALV-numero tai poista yritysvalinta.",
    "admin.invoiceDownload": "Lataa lasku (PDF)",
    "admin.vatNumberLabel": "ALV-numero",
    "admin.reverseChargeNote": "Käännetty verovelvollisuus. Ostaja tilittää arvonlisäveron.",
    "purchase.err.checkoutFailed": "Maksun aloitus epäonnistui. Yritä uudelleen.",

    // ---- admin page ----
    "admin.eyebrow": "Hallinta",
    "admin.heading": "{name} muotokuva",
    "admin.heading.fb": "Muotokuva: {name}",
    "admin.paymentConfirming": "Vahvistetaan maksua… Tämä voi kestää hetken. Älä sulje sivua.",
    "admin.paymentSuccess": "Kiitos ostoksesta! Lahja on nyt avattu. Sait myös sähköpostin, jossa on paluulinkki tälle sivulle.",
    "admin.resendLinks": "Lähetä linkit uudelleen",
    "admin.retentionDeleted": "Vastaukset on poistettu säilytysajan päätyttyä.",
    "admin.retentionPre": "Vastaukset poistetaan",
    "admin.retentionDays": "{n} päivän",
    "admin.retentionPost": "kuluttua säilytysajan päätyttyä. Poiston jälkeen valmis muotokuva säilyy, mutta vastauksia ei voi enää palauttaa eikä muotokuvaa luoda uudelleen. Lataa vastaukset talteen ennen sitä.",
    "admin.share.title": "Jaa keräys",
    "admin.share.qrAlt": "QR-koodi",
    "admin.share.copy": "Kopioi linkki",
    "admin.stats.answers": "Vastauksia",
    "admin.stats.status": "Keräyksen tila",
    "admin.status.closed": "Suljettu",
    "admin.status.open": "Avoinna",
    "admin.closesLabel": "Sulkeutuu:",
    "admin.extend": "Pidennä",
    "admin.extendTitle": "Pidennä vastausaikaa",
    "admin.extendDesc": "Valitse uusi päivä, enintään 30 päivää tästä päivästä. Tämä avaa keräyksen uudelleen.",
    "admin.extendDateLabel": "Uusi viimeinen vastauspäivä",
    "admin.regenNote": "Yksi vastaus on poistettu. Muotokuva kannattaa luoda uudelleen.",
    "admin.rebuildNote": "Vastaus on poistettu. Kirja kannattaa rakentaa uudelleen (ei kuluta muotokuvan luontikertoja).",
    "admin.rebuildButton": "Rakenna kirja uudelleen",
    "admin.rebuilding": "Rakennetaan…",
    "admin.portraitTitle": "Muotokuva",
    "admin.portraitSubtitle": "Tekoäly tiivistää vastaukset yhdeksi tekstiksi.",
    "admin.generating": "Luodaan…",
    "admin.regenerate": "Luo uudelleen ({n} jäljellä)",
    "admin.generate": "Luo muotokuva",
    "admin.noAnswersYet": "Muotokuvan voi luoda, kun vastauksia on kertynyt.",
    "admin.creditsTitle": "Tämän muotokuvan tekivät",
    "admin.creditsAnonOnly": "Tämän muotokuvan teki {n} ystävää",
    "admin.creditsAnonLine": "sekä {n} nimetöntä ystävää",
    "admin.feedbackTitle": "Miltä teksti tuntui?",
    "admin.feedbackPlaceholder": "Vapaaehtoinen palaute (vapaaehtoinen)",
    "admin.feedbackThanks": "Kiitos palautteesta!",
    "admin.germanTitle": "Saksankielinen versio",
    "admin.germanNote": "Luo uskollinen saksankielinen käännös valmiista muotokuvasta, myös tekijät-osiosta. Yksittäisiä vastauksia ei käännetä. Käännös tallennetaan erikseen ja sen voi ladata omana PDF-tiedostonaan.",
    "admin.createGerman": "Luo saksankielinen versio",
    "admin.regenGerman": "Luo saksankielinen versio uudelleen",
    "admin.translating": "Käännetään…",
    "admin.downloadPortraitDePdf": "Muotokuva – saksa (PDF)",
    "admin.toast.germanCreated": "Saksankielinen versio luotu",
    "admin.toast.germanFailed": "Käännös epäonnistui",
    "admin.giftEyebrow": "Lahjan jakaminen",
    "admin.giftTitle": "Jaa valmis lahja",
    "admin.copyGiftLink": "Kopioi lahjalinkki",
    "admin.openGiftPage": "Avaa lahjasivu",
    "admin.releaseDone": "Lahja on julkaistu osallistujille.",
    "admin.releaseInfo": "Kun julkaiset lahjan, lähetämme lahjalinkin niille osallistujille, jotka jättivät sähköpostinsa. Osallistujat eivät saa linkkiä ennen kuin julkaiset sen.",
    "admin.releaseButton": "Julkaise lahja osallistujille",
    "admin.releaseConfirmTitle": "Julkaistaanko lahja?",
    "admin.releaseConfirmDesc": "Lahjalinkki lähetetään {n} osallistujalle, joka jätti sähköpostinsa. Tämä paljastaa lahjan – tee tämä vasta kun on oikea hetki.",
    "admin.releasing": "Julkaistaan…",
    "admin.releaseNow": "Julkaise nyt",
    "admin.addonsTitle": "Tulossa pian",
    "admin.addonsSubtitle": "Nämä eivät ole vielä ostettavissa. Jätä sähköpostisi, niin ilmoitamme sinulle kun ne julkaistaan. Kyseessä on vain ilmoitus – ei tilaus, ei varaus, ei maksu.",
    "admin.addonEmailLabel": "Sähköposti",
    "admin.addonAudioTitle": "Ääniversio",
    "admin.addonAudioDesc": "Muotokuva ääneen luettuna.",
    "admin.addonPrintTitle": "Painettu kirja",
    "admin.addonPrintDesc": "Fyysinen, painettu versio.",
    "admin.addonNotifyMe": "Ilmoita minulle",
    "admin.addonNotified": "Ilmoitamme sinulle",
    "admin.answersTitle": "Vastaukset",
    "admin.noAnswers": "Ei vielä vastauksia.",
    "admin.anonFriend": "Nimetön ystävä",
    "admin.badgeAnon": "Nimetön",
    "admin.badgeNamed": "nimi näkyy",
    "admin.deleteAnswerTitle": "Poistetaanko vastaus?",
    "admin.deleteAnswerDesc": "Tätä toimintoa ei voi perua.",
    "admin.delete": "Poista",
    "admin.downloadsTitle": "Lataa ja hallinnoi",
    "admin.downloadAnswersTxt": "Vastaukset (teksti)",
    "admin.downloadAnswersCsv": "Vastaukset (CSV)",
    "admin.downloadPortraitTxt": "Muotokuva (teksti)",
    "admin.downloadPortraitPdf": "Muotokuva (PDF)",
    "admin.downloadBookPdf": "Kirja (PDF)",
    "admin.deleteNow": "Poista keräys ja kaikki vastaukset nyt",
    "admin.deleteNowTitle": "Poistetaanko keräys pysyvästi?",
    "admin.deleteNowDesc": "Tämä poistaa keräyksen, kaikki vastaukset ja valmiin muotokuvan lopullisesti. Poistoa ei voi perua eikä mitään voi palauttaa. Linkki lakkaa toimimasta.",
    "admin.deletingNow": "Poistetaan…",
    "admin.deletePermanently": "Poista lopullisesti",
    "admin.marketingConsent": "Saamme käyttää tätä muotokuvaa esimerkkinä markkinoinnissa.",
    "admin.error.title": "Pääsy estetty",
    "admin.error.body": "Keräystä ei löytynyt tai hallintalinkki on virheellinen.",
    "admin.deletedScreen.title": "Keräys on poistettu",
    "admin.deletedScreen.body": "Keräys, vastaukset ja muotokuva on poistettu pysyvästi. Linkki ei ole enää käytössä.",
    "admin.toast.paymentCancelled": "Maksu peruttiin. Mitään ei menetetty – voit ostaa myöhemmin.",
    "admin.toast.paymentConfirmed": "Maksu vahvistettu! Lahja on avattu.",
    "admin.toast.paymentSlow": "Maksun vahvistus kesti odotettua kauemmin. Päivitä sivu hetken kuluttua.",
    "admin.toast.opened": "Keräys avattu",
    "admin.toast.closed": "Keräys suljettu",
    "admin.toast.statusFailed": "Tilan päivitys epäonnistui",
    "admin.toast.extended": "Vastausaikaa pidennetty",
    "admin.toast.extendFailed": "Pidentäminen epäonnistui",
    "admin.toast.bookRebuilt": "Kirja rakennettu uudelleen",
    "admin.toast.rebuildFailed": "Rakentaminen epäonnistui",
    "admin.toast.feedbackThanks": "Kiitos palautteesta!",
    "admin.toast.feedbackFailed": "Lähetys epäonnistui",
    "admin.toast.answerDeleted": "Vastaus poistettu",
    "admin.toast.portraitCreated": "Muotokuva luotu",
    "admin.toast.portraitFailed": "Muotokuvan luonti epäonnistui",
    "admin.toast.releaseAlready": "Lahja on jo julkaistu osallistujille.",
    "admin.toast.releaseDone": "Lahja julkaistu {n} osallistujalle.",
    "admin.toast.releaseFailed": "Julkaisu epäonnistui",
    "admin.toast.addonEmailMissing": "Sähköposti puuttuu",
    "admin.toast.addonThanks": "Kiitos! Ilmoitamme sinulle sähköpostitse.",
    "admin.toast.textCopied": "Teksti kopioitu",
    "admin.toast.linksSent": "Linkit lähetetty osoitteeseen {email}",
    "admin.toast.emailFailed": "Sähköpostin lähetys ei onnistunut",
    "admin.toast.sendFailed": "Lähetys epäonnistui",
    "admin.toast.giftLinkCopied": "Lahjalinkki kopioitu",

    // ---- owner page ----
    "owner.title": "Ylläpito",
    "owner.pricing.title": "Hinnoittelu",
    "owner.pricing.summaryPre": "Nykyiset hinnat: kuluttaja",
    "owner.pricing.summaryMid": "(sis. alv), yritys",
    "owner.pricing.summaryPost": "(ei käytössä).",
    "owner.pricing.updatedAt": " Päivitetty {date}.",
    "owner.pricing.notChanged": " Ei muutettu.",
    "owner.pricing.consumerLabel": "Kuluttajahinta (€, sis. alv)",
    "owner.pricing.companyLabel": "Yrityshinta (€, ei käytössä)",
    "owner.pricing.save": "Tallenna hinnat",
    "owner.pricing.confirmTitle": "Vahvista hintamuutos",
    "owner.pricing.confirmDesc": "Uusi kuluttajahinta {consumer} € ja yrityshinta {company} €. Muutos ei vaikuta jo maksettuihin tai käynnissä oleviin ostoihin.",
    "owner.pricing.saved": "Hinnat tallennettu",
    "owner.freeLinks.title": "Ilmaiset linkit",
    "owner.freeLinks.desc": "Jokainen linkki avaa muotokuvan ja e-kirjan maksutta (arvo 29 €). Linkki on kertakäyttöinen – se merkitään käytetyksi vasta kun keräys luodaan. Pari on tarkoitettu yhdelle saajalle: toinen linkki käyttöön, toinen jaettavaksi eteenpäin.",
    "owner.freeLinks.labelLabel": "Nimilappu (valinnainen)",
    "owner.freeLinks.labelPlaceholder": "esim. Roby gift",
    "owner.freeLinks.countLabel": "Määrä",
    "owner.freeLinks.create": "Luo linkit",
    "owner.freeLinks.createPair": "Luo pari",
    "owner.freeLinks.countBadge": "{n} linkkiä",
    "owner.freeLinks.copyAll": "Kopioi kaikki käyttämättömät linkit",
    "owner.freeLinks.statusUnused": "Käyttämätön",
    "owner.freeLinks.statusUsed": "Käytetty",
    "owner.freeLinks.statusExpired": "Vanhentunut",
    "owner.freeLinks.noLabel": "(ei nimilappua)",
    "owner.freeLinks.createdExpires": "Luotu {created} · Vanhenee {expires}",
    "owner.freeLinks.copy": "Kopioi",
    "owner.freeLinks.pairCreated": "Pari luotu",
    "owner.freeLinks.createdSingular": "{n} linkki luotu",
    "owner.freeLinks.createdPlural": "{n} linkkiä luotu",
    "owner.freeLinks.createFailed": "Linkkien luonti epäonnistui",
    "owner.freeLinks.noneUnused": "Ei käyttämättömiä linkkejä",
    "owner.freeLinks.copiedCount": "{n} linkkiä kopioitu",
    "owner.freeLinks.sentAt": "Lähetetty {date}",
    "owner.freeLinks.notSent": "Ei lähetetty",
    "owner.freeLinks.notePlaceholder": "Muistiinpano (esim. kenelle)",
    "owner.freeLinks.delete": "Poista",
    "owner.freeLinks.deleteSelected": "Poista valitut",
    "owner.freeLinks.deleteTitle": "Poistetaanko linkit?",
    "owner.freeLinks.deleteDesc": "Valitut linkit poistetaan.",
    "owner.freeLinks.deleteUsedWarn": "Osa valituista linkeistä on käytetty. Linkit poistetaan, mutta niiden kautta luodut keräykset säilyvät.",
    "owner.freeLinks.deleted": "Poistettu",
    "owner.collections.delete": "Poista",
    "owner.collections.deleteSelected": "Poista valitut",
    "owner.collections.deleteTitle": "Poistetaanko keräys?",
    "owner.collections.deleteDesc": "Poistetaan keräys, kaikki {n} vastausta ja valmiit tiedostot. Tätä ei voi perua.",
    "owner.collections.deleteManyDesc": "Poistetaan {c} keräystä ja kaikki niiden vastaukset ja tiedostot. Tätä ei voi perua.",
    "owner.collections.deleted": "Poistettu",
    "owner.collections.testBadge": "Testi",
    "owner.collections.testToggle": "Testi",
    "owner.nameForms.toggle": "Nimimuodot",
    "owner.nameForms.title": "Nimen taivutusmuodot",
    "owner.nameForms.desc": "Käytetään otsikoissa. Korjaa käsin, jos jokin muoto on väärin. Tyhjä kenttä käyttää varamuotoilua ilman taivutusta.",
    "owner.nameForms.fiGenitive": "Suomi – genetiivi (esim. Matin)",
    "owner.nameForms.fiAllative": "Suomi – allatiivi (esim. Matille)",
    "owner.nameForms.deGenitive": "Saksa – genetiivi (esim. Mattis)",
    "owner.nameForms.save": "Tallenna nimimuodot",
    "owner.nameForms.saved": "Nimimuodot tallennettu",
    "owner.collections.showAnswers": "Näytä vastaukset",
    "owner.collections.hideAnswers": "Piilota vastaukset",
    "owner.collections.anon": "Nimetön ystävä",
    "owner.collections.deleteAnswerTitle": "Poistetaanko vastaus?",
    "owner.collections.deleteAnswerDesc": "Vastaus poistetaan pysyvästi ja muotokuva on luotava uudelleen.",
    "owner.collections.answerDeleted": "Vastaus poistettu",
    "owner.collections.selected": "{n} valittu",
    "owner.collections.title": "Keräykset ({n})",
    "owner.collections.empty": "Ei keräyksiä.",
    "owner.collections.organizer": "Järjestäjä: {name} · {date}",
    "owner.collections.closes": "Sulkeutuu: {date}",
    "owner.collections.answers": "{n} vastausta",
    "owner.collections.open": "Avoinna",
    "owner.collections.closed": "Suljettu",
    "owner.collections.consentYes": "Markkinointilupa: kyllä",
    "owner.collections.consentNo": "Markkinointilupa: ei",
    "owner.collections.admin": "Hallinta",
    "owner.occasions.title": "Tilaisuudet ({n})",
    "owner.occasions.empty": "Ei tilaisuuksia.",
    "owner.occasions.public": "Julkinen",
    "owner.occasions.private": "Yksityinen",
    "owner.occasions.usage": "Käytetty {n} kertaa",
    "owner.occasions.publicToggle": "Julkinen",
    "owner.occasions.titlePlaceholder": "Otsikko",
    "owner.occasions.descPlaceholder": "Kuvaus",
    "owner.occasions.published": "Tilaisuus julkaistu",
    "owner.occasions.hidden": "Tilaisuus piilotettu",
    "owner.occasions.updateFailed": "Päivitys epäonnistui",
    "owner.occasions.saved": "Tallennettu",
    "owner.occasions.questionsFi": "Kysymykset (suomeksi)",
    "owner.occasions.questionsDe": "Kysymykset (saksaksi)",
    "owner.occasions.questionPlaceholder": "Kirjoita kysymys…",
    "owner.occasions.addQuestion": "Lisää kysymys",
    "owner.occasions.deHint": "Vapaaehtoinen. Kun lisäät saksankieliset kysymykset, vastaajalle näkyy Suomeksi / Auf Deutsch -kielivalinta.",
    "owner.occasions.saveQuestions": "Tallenna kysymykset",
    "owner.events.title": "Tapahtumat ({n})",
    "owner.events.empty": "Ei tapahtumia.",
    "owner.events.answers": "Vastauksia:",
    "owner.events.regens": "Uudelleenluonteja:",
    "owner.events.rating": "Arvio:",
    "owner.leads.title": "Kerätyt sähköpostit ({n})",
    "owner.leads.empty": "Ei sähköposteja.",
    "owner.notFound": "Sivua ei löytynyt.",
  },

  en: {
    "common.loading": "Loading…",
    "common.notFound": "Not found",
    "common.linkCopied": "Link copied",
    "common.emailPlaceholder": "you@email.com",
    "common.sending": "Sending…",
    "common.creating": "Creating…",
    "common.saving": "Saving…",
    "common.saveFailed": "Saving failed",
    "common.deleteFailed": "Deletion failed",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.copy": "Copy",
    "common.copied": "Copied",
    "common.send": "Send",
    "common.contact": "Contact:",

    "nav.occasions": "Occasions",
    "footer.privacy": "Privacy",
    "footer.terms": "Terms",
    "footer.legal": "Service provided by {name} (CIF {cif}), {address}. Contact: {email}",
    "footer.legalPre": "Service provided by {name} (CIF {cif}), {address}. Contact:",

    "report.trigger": "Report abuse or request removal of your answer",
    "report.title": "Report abuse or request removal",
    "report.desc": "Tell us briefly what this is about. We'll contact you at the address you provide.",
    "report.confirmation": "Report received. Thank you!",
    "report.messageLabel": "Message",
    "report.messagePlaceholder": "Describe the situation…",
    "report.emailLabel": "Your email",
    "report.submit": "Send report",
    "report.err.fill": "Fill in the message and email",
    "report.err.failed": "Sending failed, please try again",

    "home.recover.trigger": "Lost your admin link?",
    "home.recover.title": "Lost your admin link?",
    "home.recover.desc": "Enter the email you used to create the collection. We'll send the admin links there.",
    "home.recover.submit": "Send links",
    "home.freeBanner": "This portrait is free (value 29 EUR). The price includes both the portrait and the e-book. The link must be used by {date}.",
    "home.hero.title": "A warm gift from friends",
    "home.hero.subtitle": "Gather answers from friends and loved ones into a single written portrait. Collect memories and greetings with your own link, and let AI weave them into a coherent story you can read aloud or give as a gift.",
    "home.sample.eyebrow": "Example of a finished portrait",
    "home.sample.text": "Aino is a person whose presence is noticed only once she leaves the room.",
    "home.sample.note": "You get the written portrait as text - not an image or drawing.",
    "home.form.subjectPerson": "Who is the gift for?",
    "home.form.subjectCommunity": "Subject of the portrait",
    "home.form.namePlaceholderPerson": "The hero's name, e.g. Maija",
    "home.form.namePlaceholderCommunity": "e.g. the name of the group or community",
    "home.form.giver": "Your name",
    "home.form.giverPlaceholder": "Organizer's name, e.g. Ville",
    "home.form.email": "Your email",
    "home.form.emailHelp": "We'll send the links to this address. The admin link is the only access to the collection, so keep the message.",
    "home.form.occasion": "Occasion",
    "home.form.occasionPlaceholder": "e.g. Birthday, Retirement, Wedding",
    "home.form.description": "Description (optional)",
    "home.form.descriptionPlaceholder": "Short description of the occasion",
    "home.form.questions": "Questions ({n}/10)",
    "home.form.nimiHintPre": "Tip:",
    "home.form.nimiHintPost": "is automatically replaced with the portrait subject's name.",
    "home.form.questionPlaceholder": "Write a question…",
    "home.form.nimiWarnPre": "Avoid a case ending after the name. Write the question so that",
    "home.form.nimiWarnPost": "stays in the base form.",
    "home.form.addQuestion": "Add question",
    "home.form.closesAt": "Last day to answer",
    "home.form.closesHelp": "The collection closes at the end of this day. Up to 30 days.",
    "home.form.submit": "Create collection",
    "home.usedFor": "What this has been used for",
    "home.success.title": "The collection for {name} is ready!",
    "home.success.subtitle": "Share the answer link below with friends.",
    "home.success.emailSent": "The links have also been sent to {email}",
    "home.success.emailFailed": "Sending the links to {email} failed – save the links below.",
    "home.success.publicLabel": "Answer link for friends",
    "home.success.publicHint": "Share this with everyone you want to include in the gift.",
    "home.success.adminLabel": "Your admin link",
    "home.success.adminHint": "Here you can see the answers and create the portrait.",
    "home.success.warnStrong": "Save the admin link now.",
    "home.success.warnRest": "It is the only way to access the answers, and it cannot be recovered afterwards.",
    "home.success.goAdmin": "Go to admin",
    "home.err.bothNames": "Fill in both names",
    "home.err.email": "Enter your email address",
    "home.err.occasionName": "Give the occasion a name",
    "home.err.atLeastOneQuestion": "Add at least one question",
    "home.err.createFailed": "Creating the collection failed",
    "home.err.recoverEmail": "Enter an email address",
    "home.err.recoverFailed": "Something went wrong, please try again",

    "answer.submit": "Send answer",
    "answer.submitting": "Saving…",
    "answer.next": "Next",
    "answer.prev": "Back",
    "answer.saveDraft": "Continue later",
    "answer.progress": "Question {n}/{total}",
    "answer.placeholder": "Write your answer here…",
    "answer.emailHelp": "We only use it if you want to remove your answer later.",
    "answer.draftRestored": "Restored a previously saved draft.",
    "answer.draftSaved": "Draft saved on this device. You can continue later from the same link.",
    "answer.err.atLeastOne": "Answer at least one question",
    "answer.err.nameOrAnon": "Write your name or choose to answer anonymously",
    "answer.err.submitFailed": "Saving failed",
    "answer.notFound.title": "Collection not found",
    "answer.notFound.body": "Check the link and try again.",
    "answer.closed.title": "The collection is closed, thank you!",
    "answer.closed.body": "Answers are no longer accepted.",
    "answer.headingCommunity": "Portrait: {name}",
    "answer.headingPerson": "Birthday gift for {name}",
    "answer.intro": "We're putting together a gift for {name}: {occasion}. Answer a few questions, it takes about two minutes. The answers are summarised with AI into a single portrait. No one sees individual answers without your permission, and they are deleted after the celebration.",
    "answer.deadline": "You have until {date} to answer.",
    "answer.privacyLink": "Read the privacy policy",
    "answer.bookNotice": "Your answer is combined into one short portrait, and everything you write is also printed in full on your own page in the book.",
    "answer.liveCounter": "{n} people have answered.",
    "answer.nameLabel": "Name",
    "answer.namePlaceholder": "Your first name",
    "answer.anonLabel": "I answer anonymously",
    "answer.emailLabel": "Your email (optional)",
    "answer.langFi": "Suomeksi",
    "answer.langDe": "Auf Deutsch",

    "thankyou.heading": "Thank you!",
    "thankyou.saved": "Your answer has been saved.",
    "thankyou.ctaTitle": "Want to make a portrait like this for someone yourself?",
    "thankyou.ctaButton": "Make your own portrait",
    "thankyou.leadConfirmation": "Thank you! You're on the list.",
    "thankyou.leadLabel": "Leave your email and I'll tell you about new occasions and features",
    "thankyou.privacy": "Privacy",
    "thankyou.err.emailEmpty": "Enter an email address",
    "thankyou.err.saveFailed": "Saving failed, check the address",

    "celebration.notReady.title": "The gift is not ready yet",
    "celebration.notReady.body": "Come back again in a moment.",
    "celebration.readAll": "Read everyone's answers",
    "celebration.downloadBook": "Download the book (PDF)",

    "removal.deleted": "Your answer has been deleted",
    "removal.notFound": "Answer not found",
    "removal.deletedBody": "Thank you. Your answer has been permanently deleted from the database.",
    "removal.notFoundBody": "The answer may already be deleted, or the link has expired.",
    "removal.title": "Delete your answer",
    "removal.confirmBody": "Do you want to delete your answer from the collection {name}? Deletion is permanent and cannot be undone.",
    "removal.button": "Delete my answer",
    "removal.deleting": "Deleting…",
    "removal.success": "Your answer has been deleted",

    "privacy.title": "Privacy",
    "privacy.tradingAs": "(trading as Portwrite)",
    "privacy.registrar": "The service is provided by and the data controller is Sunbnb España SL, which offers the service under the name Portwrite.",

    "terms.title": "Terms",
    "terms.provider": "Service provider",
    "terms.serviceTitle": "Service description",
    "terms.serviceBodyPre": "Portwrite gathers answers from friends and loved ones into a single AI-written portrait. The portrait is",
    "terms.serviceBodyStrong": "written text",
    "terms.serviceBodyPost": "– not an image or drawing – and it is delivered as text as well as a downloadable e-book (PDF) and a web version.",
    "terms.priceTitle": "Price and payment",
    "terms.priceBody": "Collecting answers and creating the portrait is free. Unlocking the finished portrait and e-book costs the consumer 29 € (VAT included). Payment is made securely via Stripe. You may optionally provide a company name and VAT ID for invoicing; it does not change the price.",
    "terms.deliveryTitle": "Delivery",
    "terms.deliveryPre": "The portrait and e-book are unlocked and delivered",
    "terms.deliveryStrong": "immediately after payment",
    "terms.deliveryPost": "to the admin page, and the buyer receives a confirmation by email.",
    "terms.withdrawalTitle": "Right of withdrawal",
    "terms.withdrawalPre": "This is digital content delivered electronically. The buyer accepts at payment that delivery begins immediately.",
    "terms.withdrawalStrong": "The 14-day right of withdrawal lapses once delivery has begun with the buyer's express consent.",
    "terms.withdrawalPost": "Consent is stored in the order details with a timestamp.",
    "terms.liabilityTitle": "Limitation of liability",
    "terms.liabilityBody": "The service is provided as is. The portrait text is produced by AI based on participants' answers, and the service provider is not responsible for the complete accuracy of the content or its suitability for a particular purpose. The service provider's liability is limited to the amount paid for the service at most.",
    "terms.lawTitle": "Applicable law and dispute resolution",
    "terms.lawPre": "These terms are governed by Spanish law. A consumer may have the right to bring a dispute before a consumer dispute body. Disagreements are primarily sought to be resolved by agreement by contacting",

    "occasions.title": "Occasions",
    "occasions.subtitle": "Ready-made templates for putting together a portrait. Choose a template or create your own.",
    "occasions.templateBadge": "Template",
    "occasions.usage": "Used {n} times",
    "occasions.use": "Use this as a template",
    "occasions.createOwn": "Create your own occasion",

    "free.used": "This free link has already been used.",
    "free.expired": "This free link has expired.",
    "free.invalid": "Link not found.",
    "free.stillCreate": "You can still create a normal portrait. Collecting answers is free.",
    "free.startNormal": "Create a normal portrait",

    "purchase.previewEyebrow": "Preview",
    "purchase.previewTitle": "This is how the gift looks",
    "purchase.previewSubtitle": "You see the beginning below. The full portrait and e-book unlock after purchase.",
    "purchase.questionsTitle": "Questions",
    "purchase.morePages": "…and {n} more pages",
    "purchase.totalPages": "{n} pages in total",
    "purchase.sellerPre": "Seller:",
    "purchase.sellerTradingAs": "(trading as Portwrite), CIF {cif}. Contact:",
    "purchase.includesPortrait": "Portrait & e-book (PDF)",
    "purchase.includesWeb": "Web version",
    "purchase.buy": "Buy",
    "purchase.redirecting": "Redirecting to payment…",
    "purchase.consentMain": "I accept that the portrait is delivered immediately after payment, and I understand I lose the 14-day right of withdrawal once delivery has begun.",
    "purchase.consentAcceptPre": "I also accept the",
    "purchase.consentTerms": "terms",
    "purchase.consentAnd": "and",
    "purchase.consentPrivacy": "privacy policy",
    "purchase.companyNote": "You may optionally add a company name and VAT ID at payment for invoicing. It does not change the price.",
    "purchase.err.checkoutFailed": "Starting the payment failed. Please try again.",

    "admin.eyebrow": "Admin",
    "admin.heading": "Portrait of {name}",
    "admin.paymentConfirming": "Confirming payment… This may take a moment. Don't close the page.",
    "admin.paymentSuccess": "Thank you for your purchase! The gift is now unlocked. You also received an email with a return link to this page.",
    "admin.resendLinks": "Resend links",
    "admin.retentionDeleted": "The answers have been deleted after the retention period ended.",
    "admin.retentionPre": "The answers will be deleted in",
    "admin.retentionDays": "{n} days",
    "admin.retentionPost": "after the retention period ends. After deletion the finished portrait remains, but answers can no longer be recovered and the portrait cannot be regenerated. Download the answers first.",
    "admin.share.title": "Share the collection",
    "admin.share.qrAlt": "QR code",
    "admin.share.copy": "Copy link",
    "admin.stats.answers": "Answers",
    "admin.stats.status": "Collection status",
    "admin.status.closed": "Closed",
    "admin.status.open": "Open",
    "admin.closesLabel": "Closes:",
    "admin.extend": "Extend",
    "admin.extendTitle": "Extend the answer time",
    "admin.extendDesc": "Choose a new date, up to 30 days from today. This reopens the collection.",
    "admin.extendDateLabel": "New last day to answer",
    "admin.regenNote": "One answer has been deleted. It's worth regenerating the portrait.",
    "admin.rebuildNote": "An answer has been deleted. It's worth rebuilding the book (does not use portrait generations).",
    "admin.rebuildButton": "Rebuild the book",
    "admin.rebuilding": "Rebuilding…",
    "admin.portraitTitle": "Portrait",
    "admin.portraitSubtitle": "AI summarises the answers into a single text.",
    "admin.generating": "Creating…",
    "admin.regenerate": "Regenerate ({n} left)",
    "admin.generate": "Create portrait",
    "admin.noAnswersYet": "The portrait can be created once answers have accumulated.",
    "admin.creditsTitle": "This portrait was made by",
    "admin.creditsAnonOnly": "This portrait was made by {n} friends",
    "admin.creditsAnonLine": "and {n} anonymous friends",
    "admin.feedbackTitle": "How did the text feel?",
    "admin.feedbackPlaceholder": "Optional feedback (optional)",
    "admin.feedbackThanks": "Thanks for the feedback!",
    "admin.germanTitle": "German version",
    "admin.germanNote": "Create a faithful German translation of the finished portrait, including the credits section. Individual answers are not translated. The translation is stored separately and can be downloaded as its own PDF.",
    "admin.createGerman": "Create German version",
    "admin.regenGerman": "Recreate German version",
    "admin.translating": "Translating…",
    "admin.downloadPortraitDePdf": "Portrait – German (PDF)",
    "admin.toast.germanCreated": "German version created",
    "admin.toast.germanFailed": "Translation failed",
    "admin.giftEyebrow": "Sharing the gift",
    "admin.giftTitle": "Share the finished gift",
    "admin.copyGiftLink": "Copy gift link",
    "admin.openGiftPage": "Open gift page",
    "admin.releaseDone": "The gift has been released to participants.",
    "admin.releaseInfo": "When you release the gift, we'll send the gift link to the participants who left their email. Participants don't receive the link until you release it.",
    "admin.releaseButton": "Release the gift to participants",
    "admin.releaseConfirmTitle": "Release the gift?",
    "admin.releaseConfirmDesc": "The gift link will be sent to {n} participants who left their email. This reveals the gift – do this only when the time is right.",
    "admin.releasing": "Releasing…",
    "admin.releaseNow": "Release now",
    "admin.addonsTitle": "Coming soon",
    "admin.addonsSubtitle": "These are not yet available for purchase. Leave your email and we'll notify you when they launch. This is only a notification – not an order, reservation, or payment.",
    "admin.addonEmailLabel": "Email",
    "admin.addonAudioTitle": "Audio version",
    "admin.addonAudioDesc": "The portrait read aloud.",
    "admin.addonPrintTitle": "Printed book",
    "admin.addonPrintDesc": "A physical, printed version.",
    "admin.addonNotifyMe": "Notify me",
    "admin.addonNotified": "We'll notify you",
    "admin.answersTitle": "Answers",
    "admin.noAnswers": "No answers yet.",
    "admin.anonFriend": "Anonymous friend",
    "admin.badgeAnon": "Anonymous",
    "admin.badgeNamed": "name shown",
    "admin.deleteAnswerTitle": "Delete the answer?",
    "admin.deleteAnswerDesc": "This action cannot be undone.",
    "admin.delete": "Delete",
    "admin.downloadsTitle": "Download and manage",
    "admin.downloadAnswersTxt": "Answers (text)",
    "admin.downloadAnswersCsv": "Answers (CSV)",
    "admin.downloadPortraitTxt": "Portrait (text)",
    "admin.downloadPortraitPdf": "Portrait (PDF)",
    "admin.downloadBookPdf": "Book (PDF)",
    "admin.deleteNow": "Delete the collection and all answers now",
    "admin.deleteNowTitle": "Delete the collection permanently?",
    "admin.deleteNowDesc": "This permanently deletes the collection, all answers and the finished portrait. Deletion cannot be undone and nothing can be recovered. The link stops working.",
    "admin.deletingNow": "Deleting…",
    "admin.deletePermanently": "Delete permanently",
    "admin.marketingConsent": "We may use this portrait as an example in marketing.",
    "admin.error.title": "Access denied",
    "admin.error.body": "The collection was not found or the admin link is invalid.",
    "admin.deletedScreen.title": "The collection has been deleted",
    "admin.deletedScreen.body": "The collection, answers and portrait have been permanently deleted. The link is no longer in use.",
    "admin.toast.paymentCancelled": "Payment cancelled. Nothing was lost – you can buy later.",
    "admin.toast.paymentConfirmed": "Payment confirmed! The gift is unlocked.",
    "admin.toast.paymentSlow": "Payment confirmation took longer than expected. Refresh the page in a moment.",
    "admin.toast.opened": "Collection opened",
    "admin.toast.closed": "Collection closed",
    "admin.toast.statusFailed": "Status update failed",
    "admin.toast.extended": "Answer time extended",
    "admin.toast.extendFailed": "Extending failed",
    "admin.toast.bookRebuilt": "Book rebuilt",
    "admin.toast.rebuildFailed": "Rebuilding failed",
    "admin.toast.feedbackThanks": "Thanks for the feedback!",
    "admin.toast.feedbackFailed": "Sending failed",
    "admin.toast.answerDeleted": "Answer deleted",
    "admin.toast.portraitCreated": "Portrait created",
    "admin.toast.portraitFailed": "Creating the portrait failed",
    "admin.toast.releaseAlready": "The gift has already been released to participants.",
    "admin.toast.releaseDone": "Gift released to {n} participants.",
    "admin.toast.releaseFailed": "Release failed",
    "admin.toast.addonEmailMissing": "Email is missing",
    "admin.toast.addonThanks": "Thank you! We'll notify you by email.",
    "admin.toast.textCopied": "Text copied",
    "admin.toast.linksSent": "Links sent to {email}",
    "admin.toast.emailFailed": "Sending the email failed",
    "admin.toast.sendFailed": "Sending failed",
    "admin.toast.giftLinkCopied": "Gift link copied",

    "owner.title": "Administration",
    "owner.pricing.title": "Pricing",
    "owner.pricing.summaryPre": "Current prices: consumer",
    "owner.pricing.summaryMid": "(VAT incl.), company",
    "owner.pricing.summaryPost": "(not in use).",
    "owner.pricing.updatedAt": " Updated {date}.",
    "owner.pricing.notChanged": " Not changed.",
    "owner.pricing.consumerLabel": "Consumer price (€, VAT incl.)",
    "owner.pricing.companyLabel": "Company price (€, not in use)",
    "owner.pricing.save": "Save prices",
    "owner.pricing.confirmTitle": "Confirm price change",
    "owner.pricing.confirmDesc": "New consumer price {consumer} € and company price {company} €. The change does not affect already paid or in-progress purchases.",
    "owner.pricing.saved": "Prices saved",
    "owner.freeLinks.title": "Free links",
    "owner.freeLinks.desc": "Each link unlocks the portrait and e-book for free (value 29 €). The link is single-use – it is marked used only when a collection is created. A pair is meant for one recipient: one link to use, one to pass on.",
    "owner.freeLinks.labelLabel": "Label (optional)",
    "owner.freeLinks.labelPlaceholder": "e.g. Roby gift",
    "owner.freeLinks.countLabel": "Count",
    "owner.freeLinks.create": "Create links",
    "owner.freeLinks.createPair": "Create pair",
    "owner.freeLinks.countBadge": "{n} links",
    "owner.freeLinks.copyAll": "Copy all unused links",
    "owner.freeLinks.statusUnused": "Unused",
    "owner.freeLinks.statusUsed": "Used",
    "owner.freeLinks.statusExpired": "Expired",
    "owner.freeLinks.noLabel": "(no label)",
    "owner.freeLinks.createdExpires": "Created {created} · Expires {expires}",
    "owner.freeLinks.copy": "Copy",
    "owner.freeLinks.pairCreated": "Pair created",
    "owner.freeLinks.createdSingular": "{n} link created",
    "owner.freeLinks.createdPlural": "{n} links created",
    "owner.freeLinks.createFailed": "Creating links failed",
    "owner.freeLinks.noneUnused": "No unused links",
    "owner.freeLinks.copiedCount": "{n} links copied",
    "owner.freeLinks.sentAt": "Sent {date}",
    "owner.freeLinks.notSent": "Not sent",
    "owner.freeLinks.notePlaceholder": "Note (e.g. who it went to)",
    "owner.freeLinks.delete": "Delete",
    "owner.freeLinks.deleteSelected": "Delete selected",
    "owner.freeLinks.deleteTitle": "Delete links?",
    "owner.freeLinks.deleteDesc": "The selected links will be deleted.",
    "owner.freeLinks.deleteUsedWarn": "Some selected links have been used. The links are deleted, but the collections created from them are kept.",
    "owner.freeLinks.deleted": "Deleted",
    "owner.collections.delete": "Delete",
    "owner.collections.deleteSelected": "Delete selected",
    "owner.collections.deleteTitle": "Delete collection?",
    "owner.collections.deleteDesc": "This deletes the collection, all {n} answers and the finished files. This cannot be undone.",
    "owner.collections.deleteManyDesc": "This deletes {c} collections and all their answers and files. This cannot be undone.",
    "owner.collections.deleted": "Deleted",
    "owner.collections.testBadge": "Test",
    "owner.collections.testToggle": "Test",
    "owner.nameForms.toggle": "Name forms",
    "owner.nameForms.title": "Name case forms",
    "owner.nameForms.desc": "Used in headings. Fix by hand if a form is wrong. An empty field uses a case-free fallback.",
    "owner.nameForms.fiGenitive": "Finnish – genitive (e.g. Matin)",
    "owner.nameForms.fiAllative": "Finnish – allative (e.g. Matille)",
    "owner.nameForms.deGenitive": "German – genitive (e.g. Mattis)",
    "owner.nameForms.save": "Save name forms",
    "owner.nameForms.saved": "Name forms saved",
    "owner.collections.showAnswers": "Show answers",
    "owner.collections.hideAnswers": "Hide answers",
    "owner.collections.anon": "Anonymous friend",
    "owner.collections.deleteAnswerTitle": "Delete the answer?",
    "owner.collections.deleteAnswerDesc": "The answer is permanently deleted and the portrait must be regenerated.",
    "owner.collections.answerDeleted": "Answer deleted",
    "owner.collections.selected": "{n} selected",
    "owner.collections.title": "Collections ({n})",
    "owner.collections.empty": "No collections.",
    "owner.collections.organizer": "Organizer: {name} · {date}",
    "owner.collections.closes": "Closes: {date}",
    "owner.collections.answers": "{n} answers",
    "owner.collections.open": "Open",
    "owner.collections.closed": "Closed",
    "owner.collections.consentYes": "Marketing consent: yes",
    "owner.collections.consentNo": "Marketing consent: no",
    "owner.collections.admin": "Admin",
    "owner.occasions.title": "Occasions ({n})",
    "owner.occasions.empty": "No occasions.",
    "owner.occasions.public": "Public",
    "owner.occasions.private": "Private",
    "owner.occasions.usage": "Used {n} times",
    "owner.occasions.publicToggle": "Public",
    "owner.occasions.titlePlaceholder": "Title",
    "owner.occasions.descPlaceholder": "Description",
    "owner.occasions.published": "Occasion published",
    "owner.occasions.hidden": "Occasion hidden",
    "owner.occasions.updateFailed": "Update failed",
    "owner.occasions.saved": "Saved",
    "owner.occasions.questionsFi": "Questions (Finnish)",
    "owner.occasions.questionsDe": "Questions (German)",
    "owner.occasions.questionPlaceholder": "Write a question…",
    "owner.occasions.addQuestion": "Add question",
    "owner.occasions.deHint": "Optional. When you add German questions, respondents see a Suomeksi / Auf Deutsch language switch.",
    "owner.occasions.saveQuestions": "Save questions",
    "owner.events.title": "Events ({n})",
    "owner.events.empty": "No events.",
    "owner.events.answers": "Answers:",
    "owner.events.regens": "Regenerations:",
    "owner.events.rating": "Rating:",
    "owner.leads.title": "Collected emails ({n})",
    "owner.leads.empty": "No emails.",
    "owner.notFound": "Page not found.",
  },

  de: {
    "common.loading": "Wird geladen…",
    "common.notFound": "Nicht gefunden",
    "common.linkCopied": "Link kopiert",
    "common.emailPlaceholder": "du@email.com",
    "common.sending": "Wird gesendet…",
    "common.creating": "Wird erstellt…",
    "common.saving": "Wird gespeichert…",
    "common.saveFailed": "Speichern fehlgeschlagen",
    "common.deleteFailed": "Löschen fehlgeschlagen",
    "common.cancel": "Abbrechen",
    "common.save": "Speichern",
    "common.copy": "Kopieren",
    "common.copied": "Kopiert",
    "common.send": "Senden",
    "common.contact": "Kontakt:",

    "nav.occasions": "Anlässe",
    "footer.privacy": "Datenschutz",
    "footer.terms": "Nutzungsbedingungen",
    "footer.legal": "Angeboten von {name} (CIF {cif}), {address}. Kontakt: {email}",
    "footer.legalPre": "Angeboten von {name} (CIF {cif}), {address}. Kontakt:",

    "report.trigger": "Missbrauch melden oder Löschung deiner Antwort anfordern",
    "report.title": "Missbrauch melden oder Löschung anfordern",
    "report.desc": "Erzähle kurz, worum es geht. Wir kontaktieren dich unter der angegebenen Adresse.",
    "report.confirmation": "Meldung erhalten. Danke!",
    "report.messageLabel": "Nachricht",
    "report.messagePlaceholder": "Beschreibe die Situation…",
    "report.emailLabel": "Deine E-Mail",
    "report.submit": "Meldung senden",
    "report.err.fill": "Nachricht und E-Mail ausfüllen",
    "report.err.failed": "Senden fehlgeschlagen, bitte erneut versuchen",

    "home.recover.trigger": "Admin-Link verloren?",
    "home.recover.title": "Admin-Link verloren?",
    "home.recover.desc": "Gib die E-Mail an, mit der du die Sammlung erstellt hast. Wir senden die Admin-Links dorthin.",
    "home.recover.submit": "Links senden",
    "home.freeBanner": "Dieses Porträt ist kostenlos (Wert 29 EUR). Der Preis umfasst sowohl das Porträt als auch das E-Book. Der Link ist bis zum {date} gültig.",
    "home.hero.title": "Ein warmes Geschenk von Freunden",
    "home.hero.subtitle": "Sammle Antworten von Freunden und Angehörigen zu einem geschriebenen Porträt. Sammle Erinnerungen und Grüße mit deinem eigenen Link und lass die KI daraus eine zusammenhängende Geschichte weben, die man vorlesen oder verschenken kann.",
    "home.sample.eyebrow": "Beispiel eines fertigen Porträts",
    "home.sample.text": "Aino ist ein Mensch, dessen Anwesenheit man erst bemerkt, wenn sie den Raum verlässt.",
    "home.sample.note": "Du erhältst das geschriebene Porträt als Text - kein Bild oder keine Zeichnung.",
    "home.form.subjectPerson": "Für wen ist das Geschenk?",
    "home.form.subjectCommunity": "Motiv des Porträts",
    "home.form.namePlaceholderPerson": "Name der Person, z. B. Maija",
    "home.form.namePlaceholderCommunity": "z. B. Name der Gruppe oder Gemeinschaft",
    "home.form.giver": "Dein Name",
    "home.form.giverPlaceholder": "Name des Organisators, z. B. Ville",
    "home.form.email": "Deine E-Mail",
    "home.form.emailHelp": "Wir senden die Links an diese Adresse. Der Admin-Link ist der einzige Zugang zur Sammlung, bewahre die Nachricht daher auf.",
    "home.form.occasion": "Anlass",
    "home.form.occasionPlaceholder": "z. B. Geburtstag, Ruhestand, Hochzeit",
    "home.form.description": "Beschreibung (optional)",
    "home.form.descriptionPlaceholder": "Kurze Beschreibung des Anlasses",
    "home.form.questions": "Fragen ({n}/10)",
    "home.form.nimiHintPre": "Tipp:",
    "home.form.nimiHintPost": "wird automatisch durch den Namen der porträtierten Person ersetzt.",
    "home.form.questionPlaceholder": "Schreibe eine Frage…",
    "home.form.nimiWarnPre": "Vermeide eine Beugungsendung nach dem Namen. Schreibe die Frage so, dass",
    "home.form.nimiWarnPost": "in der Grundform bleibt.",
    "home.form.addQuestion": "Frage hinzufügen",
    "home.form.closesAt": "Letzter Antworttag",
    "home.form.closesHelp": "Die Sammlung schließt am Ende dieses Tages. Höchstens 30 Tage.",
    "home.form.submit": "Sammlung erstellen",
    "home.usedFor": "Wofür dies verwendet wurde",
    "home.success.title": "Die Sammlung für {name} ist fertig!",
    "home.success.subtitle": "Teile den Antwort-Link unten mit Freunden.",
    "home.success.emailSent": "Die Links wurden auch an {email} gesendet",
    "home.success.emailFailed": "Das Senden der Links an {email} ist fehlgeschlagen – speichere die Links unten.",
    "home.success.publicLabel": "Antwort-Link für Freunde",
    "home.success.publicHint": "Teile dies mit allen, die du in das Geschenk einbeziehen möchtest.",
    "home.success.adminLabel": "Dein Admin-Link",
    "home.success.adminHint": "Hier siehst du die Antworten und erstellst das Porträt.",
    "home.success.warnStrong": "Speichere den Admin-Link jetzt.",
    "home.success.warnRest": "Er ist der einzige Weg zu den Antworten und kann nachträglich nicht wiederhergestellt werden.",
    "home.success.goAdmin": "Zur Verwaltung",
    "home.err.bothNames": "Beide Namen ausfüllen",
    "home.err.email": "Gib deine E-Mail-Adresse ein",
    "home.err.occasionName": "Gib dem Anlass einen Namen",
    "home.err.atLeastOneQuestion": "Füge mindestens eine Frage hinzu",
    "home.err.createFailed": "Erstellen der Sammlung fehlgeschlagen",
    "home.err.recoverEmail": "Gib eine E-Mail-Adresse ein",
    "home.err.recoverFailed": "Etwas ist schiefgelaufen, bitte erneut versuchen",

    "answer.submit": "Antwort senden",
    "answer.submitting": "Wird gespeichert…",
    "answer.next": "Weiter",
    "answer.prev": "Zurück",
    "answer.saveDraft": "Später fortsetzen",
    "answer.progress": "Frage {n}/{total}",
    "answer.placeholder": "Schreibe deine Antwort hier…",
    "answer.emailHelp": "Wir verwenden sie nur, falls du deine Antwort später löschen möchtest.",
    "answer.draftRestored": "Ein zuvor gespeicherter Entwurf wurde wiederhergestellt.",
    "answer.draftSaved": "Entwurf auf diesem Gerät gespeichert. Du kannst später über denselben Link fortfahren.",
    "answer.err.atLeastOne": "Beantworte mindestens eine Frage",
    "answer.err.nameOrAnon": "Schreibe deinen Namen oder wähle die anonyme Antwort",
    "answer.err.submitFailed": "Speichern fehlgeschlagen",
    "answer.notFound.title": "Sammlung nicht gefunden",
    "answer.notFound.body": "Überprüfe den Link und versuche es erneut.",
    "answer.closed.title": "Die Sammlung ist geschlossen, danke!",
    "answer.closed.body": "Antworten werden nicht mehr angenommen.",
    "answer.headingCommunity": "Porträt: {name}",
    "answer.headingPerson": "Geburtstagsgeschenk für {name}",
    "answer.intro": "Wir stellen ein Geschenk für {name} zusammen: {occasion}. Beantworte ein paar Fragen, es dauert etwa zwei Minuten. Die Antworten werden mit KI zu einem einzigen Porträt zusammengefasst. Niemand sieht einzelne Antworten ohne deine Erlaubnis, und sie werden nach der Feier gelöscht.",
    "answer.deadline": "Du hast bis zum {date} Zeit zu antworten.",
    "answer.privacyLink": "Datenschutzerklärung lesen",
    "answer.bookNotice": "Deine Antwort wird zu einem kurzen Porträt zusammengefügt, und alles, was du schreibst, wird zusätzlich vollständig auf deiner eigenen Seite im Buch gedruckt.",
    "answer.liveCounter": "{n} Personen haben geantwortet.",
    "answer.nameLabel": "Name",
    "answer.namePlaceholder": "Dein Vorname",
    "answer.anonLabel": "Ich antworte anonym",
    "answer.emailLabel": "Deine E-Mail (optional)",
    "answer.langFi": "Suomeksi",
    "answer.langDe": "Auf Deutsch",

    "thankyou.heading": "Danke!",
    "thankyou.saved": "Deine Antwort wurde gespeichert.",
    "thankyou.ctaTitle": "Möchtest du selbst ein solches Porträt für jemanden erstellen?",
    "thankyou.ctaButton": "Eigenes Porträt erstellen",
    "thankyou.leadConfirmation": "Danke! Du bist auf der Liste.",
    "thankyou.leadLabel": "Hinterlasse deine E-Mail, und ich erzähle dir von neuen Anlässen und Funktionen",
    "thankyou.privacy": "Datenschutz",
    "thankyou.err.emailEmpty": "Gib eine E-Mail-Adresse ein",
    "thankyou.err.saveFailed": "Speichern fehlgeschlagen, überprüfe die Adresse",

    "celebration.notReady.title": "Das Geschenk ist noch nicht fertig",
    "celebration.notReady.body": "Komm gleich wieder vorbei.",
    "celebration.readAll": "Alle Antworten lesen",
    "celebration.downloadBook": "Buch herunterladen (PDF)",

    "removal.deleted": "Deine Antwort wurde gelöscht",
    "removal.notFound": "Antwort nicht gefunden",
    "removal.deletedBody": "Danke. Deine Antwort wurde dauerhaft aus der Datenbank gelöscht.",
    "removal.notFoundBody": "Die Antwort wurde möglicherweise bereits gelöscht, oder der Link ist abgelaufen.",
    "removal.title": "Deine Antwort löschen",
    "removal.confirmBody": "Möchtest du deine Antwort aus der Sammlung {name} löschen? Die Löschung ist endgültig und kann nicht rückgängig gemacht werden.",
    "removal.button": "Meine Antwort löschen",
    "removal.deleting": "Wird gelöscht…",
    "removal.success": "Deine Antwort wurde gelöscht",

    "privacy.title": "Datenschutz",
    "privacy.tradingAs": "(Handelsname Portwrite)",
    "privacy.registrar": "Der Dienst wird von Sunbnb España SL bereitgestellt, die als Verantwortliche fungiert und den Dienst unter dem Namen Portwrite anbietet.",

    "terms.title": "Nutzungsbedingungen",
    "terms.provider": "Diensteanbieter",
    "terms.serviceTitle": "Beschreibung des Dienstes",
    "terms.serviceBodyPre": "Portwrite sammelt Antworten von Freunden und Angehörigen zu einem von KI geschriebenen Porträt. Das Porträt ist",
    "terms.serviceBodyStrong": "geschriebener Text",
    "terms.serviceBodyPost": "– kein Bild oder keine Zeichnung – und wird als Text sowie als herunterladbares E-Book (PDF) und Webversion geliefert.",
    "terms.priceTitle": "Preis und Bezahlung",
    "terms.priceBody": "Das Sammeln von Antworten und das Erstellen des Porträts ist kostenlos. Das Freischalten des fertigen Porträts und E-Books kostet den Verbraucher 29 € (inkl. MwSt.). Die Zahlung erfolgt sicher über Stripe. Du kannst optional einen Firmennamen und eine USt-IdNr. für die Rechnungsstellung angeben; dies ändert den Preis nicht.",
    "terms.deliveryTitle": "Lieferung",
    "terms.deliveryPre": "Das Porträt und E-Book werden freigeschaltet und geliefert",
    "terms.deliveryStrong": "sofort nach der Zahlung",
    "terms.deliveryPost": "auf die Admin-Seite, und der Käufer erhält eine Bestätigung per E-Mail.",
    "terms.withdrawalTitle": "Widerrufsrecht",
    "terms.withdrawalPre": "Es handelt sich um digitale Inhalte, die elektronisch geliefert werden. Der Käufer akzeptiert bei der Zahlung, dass die Lieferung sofort beginnt.",
    "terms.withdrawalStrong": "Das 14-tägige Widerrufsrecht erlischt, sobald die Lieferung mit ausdrücklicher Zustimmung des Käufers begonnen hat.",
    "terms.withdrawalPost": "Die Zustimmung wird mit einem Zeitstempel in den Bestelldaten gespeichert.",
    "terms.liabilityTitle": "Haftungsbeschränkung",
    "terms.liabilityBody": "Der Dienst wird wie besehen bereitgestellt. Der Porträttext wird von KI auf Grundlage der Antworten der Teilnehmer erstellt, und der Diensteanbieter haftet nicht für die vollständige Richtigkeit des Inhalts oder dessen Eignung für einen bestimmten Zweck. Die Haftung des Diensteanbieters ist höchstens auf den für den Dienst gezahlten Betrag beschränkt.",
    "terms.lawTitle": "Anwendbares Recht und Streitbeilegung",
    "terms.lawPre": "Auf diese Nutzungsbedingungen ist spanisches Recht anwendbar. Ein Verbraucher hat möglicherweise das Recht, einen Streit vor eine Verbraucherschlichtungsstelle zu bringen. Meinungsverschiedenheiten werden vorrangig durch Vereinbarung gelöst, indem man Kontakt aufnimmt unter",

    "occasions.title": "Anlässe",
    "occasions.subtitle": "Fertige Vorlagen zum Zusammenstellen eines Porträts. Wähle eine Vorlage oder erstelle deine eigene.",
    "occasions.templateBadge": "Vorlage",
    "occasions.usage": "{n} Mal verwendet",
    "occasions.use": "Diese Vorlage verwenden",
    "occasions.createOwn": "Eigenen Anlass erstellen",

    "free.used": "Dieser kostenlose Link wurde bereits verwendet.",
    "free.expired": "Dieser kostenlose Link ist abgelaufen.",
    "free.invalid": "Link nicht gefunden.",
    "free.stillCreate": "Du kannst trotzdem ein normales Porträt erstellen. Das Sammeln von Antworten ist kostenlos.",
    "free.startNormal": "Normales Porträt erstellen",

    "purchase.previewEyebrow": "Vorschau",
    "purchase.previewTitle": "So sieht das Geschenk aus",
    "purchase.previewSubtitle": "Unten siehst du den Anfang. Das vollständige Porträt und E-Book werden nach dem Kauf freigeschaltet.",
    "purchase.questionsTitle": "Fragen",
    "purchase.morePages": "…und {n} weitere Seiten",
    "purchase.totalPages": "Insgesamt {n} Seiten",
    "purchase.sellerPre": "Verkäufer:",
    "purchase.sellerTradingAs": "(Handelsname Portwrite), CIF {cif}. Kontakt:",
    "purchase.includesPortrait": "Porträt & E-Book (PDF)",
    "purchase.includesWeb": "Webversion",
    "purchase.buy": "Kaufen",
    "purchase.redirecting": "Weiterleitung zur Zahlung…",
    "purchase.consentMain": "Ich akzeptiere, dass das Porträt sofort nach der Zahlung geliefert wird, und ich verstehe, dass ich das 14-tägige Widerrufsrecht verliere, sobald die Lieferung begonnen hat.",
    "purchase.consentAcceptPre": "Ich akzeptiere auch die",
    "purchase.consentTerms": "Nutzungsbedingungen",
    "purchase.consentAnd": "und",
    "purchase.consentPrivacy": "Datenschutzerklärung",
    "purchase.companyNote": "Du kannst bei der Zahlung optional einen Firmennamen und eine USt-IdNr. für die Rechnungsstellung angeben. Dies ändert den Preis nicht.",
    "purchase.err.checkoutFailed": "Das Starten der Zahlung ist fehlgeschlagen. Bitte erneut versuchen.",

    "admin.eyebrow": "Verwaltung",
    "admin.heading": "Porträt von {name}",
    "admin.paymentConfirming": "Zahlung wird bestätigt… Das kann einen Moment dauern. Schließe die Seite nicht.",
    "admin.paymentSuccess": "Danke für deinen Kauf! Das Geschenk ist jetzt freigeschaltet. Du hast auch eine E-Mail mit einem Rücklink zu dieser Seite erhalten.",
    "admin.resendLinks": "Links erneut senden",
    "admin.retentionDeleted": "Die Antworten wurden nach Ablauf der Aufbewahrungsfrist gelöscht.",
    "admin.retentionPre": "Die Antworten werden in",
    "admin.retentionDays": "{n} Tagen",
    "admin.retentionPost": "nach Ablauf der Aufbewahrungsfrist gelöscht. Nach der Löschung bleibt das fertige Porträt erhalten, aber Antworten können nicht wiederhergestellt und das Porträt nicht neu erstellt werden. Lade die Antworten vorher herunter.",
    "admin.share.title": "Sammlung teilen",
    "admin.share.qrAlt": "QR-Code",
    "admin.share.copy": "Link kopieren",
    "admin.stats.answers": "Antworten",
    "admin.stats.status": "Status der Sammlung",
    "admin.status.closed": "Geschlossen",
    "admin.status.open": "Offen",
    "admin.closesLabel": "Schließt:",
    "admin.extend": "Verlängern",
    "admin.extendTitle": "Antwortzeit verlängern",
    "admin.extendDesc": "Wähle ein neues Datum, höchstens 30 Tage ab heute. Dies öffnet die Sammlung erneut.",
    "admin.extendDateLabel": "Neuer letzter Antworttag",
    "admin.regenNote": "Eine Antwort wurde gelöscht. Es lohnt sich, das Porträt neu zu erstellen.",
    "admin.rebuildNote": "Eine Antwort wurde gelöscht. Es lohnt sich, das Buch neu zu erstellen (verbraucht keine Porträt-Erstellungen).",
    "admin.rebuildButton": "Buch neu erstellen",
    "admin.rebuilding": "Wird erstellt…",
    "admin.portraitTitle": "Porträt",
    "admin.portraitSubtitle": "Die KI fasst die Antworten zu einem einzigen Text zusammen.",
    "admin.generating": "Wird erstellt…",
    "admin.regenerate": "Neu erstellen ({n} übrig)",
    "admin.generate": "Porträt erstellen",
    "admin.noAnswersYet": "Das Porträt kann erstellt werden, sobald Antworten vorliegen.",
    "admin.creditsTitle": "Dieses Porträt wurde erstellt von",
    "admin.creditsAnonOnly": "Dieses Porträt wurde von {n} Freunden erstellt",
    "admin.creditsAnonLine": "sowie {n} anonymen Freunden",
    "admin.feedbackTitle": "Wie hat sich der Text angefühlt?",
    "admin.feedbackPlaceholder": "Optionales Feedback (optional)",
    "admin.feedbackThanks": "Danke für das Feedback!",
    "admin.germanTitle": "Deutsche Version",
    "admin.germanNote": "Erstelle eine originalgetreue deutsche Übersetzung des fertigen Porträts, einschließlich des Mitwirkenden-Abschnitts. Einzelne Antworten werden nicht übersetzt. Die Übersetzung wird separat gespeichert und kann als eigene PDF heruntergeladen werden.",
    "admin.createGerman": "Deutsche Version erstellen",
    "admin.regenGerman": "Deutsche Version neu erstellen",
    "admin.translating": "Wird übersetzt…",
    "admin.downloadPortraitDePdf": "Porträt – Deutsch (PDF)",
    "admin.toast.germanCreated": "Deutsche Version erstellt",
    "admin.toast.germanFailed": "Übersetzung fehlgeschlagen",
    "admin.giftEyebrow": "Geschenk teilen",
    "admin.giftTitle": "Fertiges Geschenk teilen",
    "admin.copyGiftLink": "Geschenk-Link kopieren",
    "admin.openGiftPage": "Geschenkseite öffnen",
    "admin.releaseDone": "Das Geschenk wurde für die Teilnehmer veröffentlicht.",
    "admin.releaseInfo": "Wenn du das Geschenk veröffentlichst, senden wir den Geschenk-Link an die Teilnehmer, die ihre E-Mail hinterlassen haben. Teilnehmer erhalten den Link erst, wenn du ihn veröffentlichst.",
    "admin.releaseButton": "Geschenk für Teilnehmer veröffentlichen",
    "admin.releaseConfirmTitle": "Geschenk veröffentlichen?",
    "admin.releaseConfirmDesc": "Der Geschenk-Link wird an {n} Teilnehmer gesendet, die ihre E-Mail hinterlassen haben. Dies enthüllt das Geschenk – tue dies erst, wenn der richtige Moment ist.",
    "admin.releasing": "Wird veröffentlicht…",
    "admin.releaseNow": "Jetzt veröffentlichen",
    "admin.addonsTitle": "Bald verfügbar",
    "admin.addonsSubtitle": "Diese sind noch nicht käuflich. Hinterlasse deine E-Mail, und wir benachrichtigen dich beim Start. Dies ist nur eine Benachrichtigung – keine Bestellung, Reservierung oder Zahlung.",
    "admin.addonEmailLabel": "E-Mail",
    "admin.addonAudioTitle": "Audioversion",
    "admin.addonAudioDesc": "Das Porträt vorgelesen.",
    "admin.addonPrintTitle": "Gedrucktes Buch",
    "admin.addonPrintDesc": "Eine physische, gedruckte Version.",
    "admin.addonNotifyMe": "Benachrichtige mich",
    "admin.addonNotified": "Wir benachrichtigen dich",
    "admin.answersTitle": "Antworten",
    "admin.noAnswers": "Noch keine Antworten.",
    "admin.anonFriend": "Anonymer Freund",
    "admin.badgeAnon": "Anonym",
    "admin.badgeNamed": "Name sichtbar",
    "admin.deleteAnswerTitle": "Antwort löschen?",
    "admin.deleteAnswerDesc": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "admin.delete": "Löschen",
    "admin.downloadsTitle": "Herunterladen und verwalten",
    "admin.downloadAnswersTxt": "Antworten (Text)",
    "admin.downloadAnswersCsv": "Antworten (CSV)",
    "admin.downloadPortraitTxt": "Porträt (Text)",
    "admin.downloadPortraitPdf": "Porträt (PDF)",
    "admin.downloadBookPdf": "Buch (PDF)",
    "admin.deleteNow": "Sammlung und alle Antworten jetzt löschen",
    "admin.deleteNowTitle": "Sammlung dauerhaft löschen?",
    "admin.deleteNowDesc": "Dies löscht die Sammlung, alle Antworten und das fertige Porträt endgültig. Die Löschung kann nicht rückgängig gemacht werden und nichts kann wiederhergestellt werden. Der Link funktioniert nicht mehr.",
    "admin.deletingNow": "Wird gelöscht…",
    "admin.deletePermanently": "Endgültig löschen",
    "admin.marketingConsent": "Wir dürfen dieses Porträt als Beispiel im Marketing verwenden.",
    "admin.error.title": "Zugriff verweigert",
    "admin.error.body": "Die Sammlung wurde nicht gefunden oder der Admin-Link ist ungültig.",
    "admin.deletedScreen.title": "Die Sammlung wurde gelöscht",
    "admin.deletedScreen.body": "Die Sammlung, Antworten und das Porträt wurden dauerhaft gelöscht. Der Link ist nicht mehr in Gebrauch.",
    "admin.toast.paymentCancelled": "Zahlung abgebrochen. Nichts ist verloren gegangen – du kannst später kaufen.",
    "admin.toast.paymentConfirmed": "Zahlung bestätigt! Das Geschenk ist freigeschaltet.",
    "admin.toast.paymentSlow": "Die Zahlungsbestätigung dauerte länger als erwartet. Aktualisiere die Seite in einem Moment.",
    "admin.toast.opened": "Sammlung geöffnet",
    "admin.toast.closed": "Sammlung geschlossen",
    "admin.toast.statusFailed": "Statusaktualisierung fehlgeschlagen",
    "admin.toast.extended": "Antwortzeit verlängert",
    "admin.toast.extendFailed": "Verlängern fehlgeschlagen",
    "admin.toast.bookRebuilt": "Buch neu erstellt",
    "admin.toast.rebuildFailed": "Erstellen fehlgeschlagen",
    "admin.toast.feedbackThanks": "Danke für das Feedback!",
    "admin.toast.feedbackFailed": "Senden fehlgeschlagen",
    "admin.toast.answerDeleted": "Antwort gelöscht",
    "admin.toast.portraitCreated": "Porträt erstellt",
    "admin.toast.portraitFailed": "Erstellen des Porträts fehlgeschlagen",
    "admin.toast.releaseAlready": "Das Geschenk wurde bereits für die Teilnehmer veröffentlicht.",
    "admin.toast.releaseDone": "Geschenk für {n} Teilnehmer veröffentlicht.",
    "admin.toast.releaseFailed": "Veröffentlichung fehlgeschlagen",
    "admin.toast.addonEmailMissing": "E-Mail fehlt",
    "admin.toast.addonThanks": "Danke! Wir benachrichtigen dich per E-Mail.",
    "admin.toast.textCopied": "Text kopiert",
    "admin.toast.linksSent": "Links gesendet an {email}",
    "admin.toast.emailFailed": "Senden der E-Mail fehlgeschlagen",
    "admin.toast.sendFailed": "Senden fehlgeschlagen",
    "admin.toast.giftLinkCopied": "Geschenk-Link kopiert",

    "owner.title": "Verwaltung",
    "owner.pricing.title": "Preisgestaltung",
    "owner.pricing.summaryPre": "Aktuelle Preise: Verbraucher",
    "owner.pricing.summaryMid": "(inkl. MwSt.), Unternehmen",
    "owner.pricing.summaryPost": "(nicht in Gebrauch).",
    "owner.pricing.updatedAt": " Aktualisiert {date}.",
    "owner.pricing.notChanged": " Nicht geändert.",
    "owner.pricing.consumerLabel": "Verbraucherpreis (€, inkl. MwSt.)",
    "owner.pricing.companyLabel": "Unternehmenspreis (€, nicht in Gebrauch)",
    "owner.pricing.save": "Preise speichern",
    "owner.pricing.confirmTitle": "Preisänderung bestätigen",
    "owner.pricing.confirmDesc": "Neuer Verbraucherpreis {consumer} € und Unternehmenspreis {company} €. Die Änderung betrifft keine bereits bezahlten oder laufenden Käufe.",
    "owner.pricing.saved": "Preise gespeichert",
    "owner.freeLinks.title": "Kostenlose Links",
    "owner.freeLinks.desc": "Jeder Link schaltet das Porträt und E-Book kostenlos frei (Wert 29 €). Der Link ist einmalig – er wird erst als verwendet markiert, wenn eine Sammlung erstellt wird. Ein Paar ist für einen Empfänger gedacht: ein Link zur Nutzung, einer zum Weitergeben.",
    "owner.freeLinks.labelLabel": "Etikett (optional)",
    "owner.freeLinks.labelPlaceholder": "z. B. Roby gift",
    "owner.freeLinks.countLabel": "Anzahl",
    "owner.freeLinks.create": "Links erstellen",
    "owner.freeLinks.createPair": "Paar erstellen",
    "owner.freeLinks.countBadge": "{n} Links",
    "owner.freeLinks.copyAll": "Alle unbenutzten Links kopieren",
    "owner.freeLinks.statusUnused": "Unbenutzt",
    "owner.freeLinks.statusUsed": "Verwendet",
    "owner.freeLinks.statusExpired": "Abgelaufen",
    "owner.freeLinks.noLabel": "(kein Etikett)",
    "owner.freeLinks.createdExpires": "Erstellt {created} · Läuft ab {expires}",
    "owner.freeLinks.copy": "Kopieren",
    "owner.freeLinks.pairCreated": "Paar erstellt",
    "owner.freeLinks.createdSingular": "{n} Link erstellt",
    "owner.freeLinks.createdPlural": "{n} Links erstellt",
    "owner.freeLinks.createFailed": "Erstellen der Links fehlgeschlagen",
    "owner.freeLinks.noneUnused": "Keine unbenutzten Links",
    "owner.freeLinks.copiedCount": "{n} Links kopiert",
    "owner.freeLinks.sentAt": "Gesendet {date}",
    "owner.freeLinks.notSent": "Nicht gesendet",
    "owner.freeLinks.notePlaceholder": "Notiz (z. B. an wen)",
    "owner.freeLinks.delete": "Löschen",
    "owner.freeLinks.deleteSelected": "Ausgewählte löschen",
    "owner.freeLinks.deleteTitle": "Links löschen?",
    "owner.freeLinks.deleteDesc": "Die ausgewählten Links werden gelöscht.",
    "owner.freeLinks.deleteUsedWarn": "Einige ausgewählte Links wurden verwendet. Die Links werden gelöscht, aber die daraus erstellten Sammlungen bleiben erhalten.",
    "owner.freeLinks.deleted": "Gelöscht",
    "owner.collections.delete": "Löschen",
    "owner.collections.deleteSelected": "Ausgewählte löschen",
    "owner.collections.deleteTitle": "Sammlung löschen?",
    "owner.collections.deleteDesc": "Dies löscht die Sammlung, alle {n} Antworten und die fertigen Dateien. Dies kann nicht rückgängig gemacht werden.",
    "owner.collections.deleteManyDesc": "Dies löscht {c} Sammlungen und alle ihre Antworten und Dateien. Dies kann nicht rückgängig gemacht werden.",
    "owner.collections.deleted": "Gelöscht",
    "owner.collections.testBadge": "Test",
    "owner.collections.testToggle": "Test",
    "owner.nameForms.toggle": "Namensformen",
    "owner.nameForms.title": "Namens-Kasusformen",
    "owner.nameForms.desc": "Wird in Überschriften verwendet. Bei Fehlern von Hand korrigieren. Ein leeres Feld nutzt eine kasusfreie Ersatzform.",
    "owner.nameForms.fiGenitive": "Finnisch – Genitiv (z. B. Matin)",
    "owner.nameForms.fiAllative": "Finnisch – Allativ (z. B. Matille)",
    "owner.nameForms.deGenitive": "Deutsch – Genitiv (z. B. Mattis)",
    "owner.nameForms.save": "Namensformen speichern",
    "owner.nameForms.saved": "Namensformen gespeichert",
    "owner.collections.showAnswers": "Antworten anzeigen",
    "owner.collections.hideAnswers": "Antworten ausblenden",
    "owner.collections.anon": "Anonymer Freund",
    "owner.collections.deleteAnswerTitle": "Antwort löschen?",
    "owner.collections.deleteAnswerDesc": "Die Antwort wird dauerhaft gelöscht und das Porträt muss neu erstellt werden.",
    "owner.collections.answerDeleted": "Antwort gelöscht",
    "owner.collections.selected": "{n} ausgewählt",
    "owner.collections.title": "Sammlungen ({n})",
    "owner.collections.empty": "Keine Sammlungen.",
    "owner.collections.organizer": "Organisator: {name} · {date}",
    "owner.collections.closes": "Schließt: {date}",
    "owner.collections.answers": "{n} Antworten",
    "owner.collections.open": "Offen",
    "owner.collections.closed": "Geschlossen",
    "owner.collections.consentYes": "Marketing-Einwilligung: ja",
    "owner.collections.consentNo": "Marketing-Einwilligung: nein",
    "owner.collections.admin": "Verwaltung",
    "owner.occasions.title": "Anlässe ({n})",
    "owner.occasions.empty": "Keine Anlässe.",
    "owner.occasions.public": "Öffentlich",
    "owner.occasions.private": "Privat",
    "owner.occasions.usage": "{n} Mal verwendet",
    "owner.occasions.publicToggle": "Öffentlich",
    "owner.occasions.titlePlaceholder": "Titel",
    "owner.occasions.descPlaceholder": "Beschreibung",
    "owner.occasions.published": "Anlass veröffentlicht",
    "owner.occasions.hidden": "Anlass ausgeblendet",
    "owner.occasions.updateFailed": "Aktualisierung fehlgeschlagen",
    "owner.occasions.saved": "Gespeichert",
    "owner.occasions.questionsFi": "Fragen (Finnisch)",
    "owner.occasions.questionsDe": "Fragen (Deutsch)",
    "owner.occasions.questionPlaceholder": "Schreibe eine Frage…",
    "owner.occasions.addQuestion": "Frage hinzufügen",
    "owner.occasions.deHint": "Optional. Wenn du deutsche Fragen hinzufügst, sehen Antwortende eine Sprachauswahl Suomeksi / Auf Deutsch.",
    "owner.occasions.saveQuestions": "Fragen speichern",
    "owner.events.title": "Ereignisse ({n})",
    "owner.events.empty": "Keine Ereignisse.",
    "owner.events.answers": "Antworten:",
    "owner.events.regens": "Neuerstellungen:",
    "owner.events.rating": "Bewertung:",
    "owner.leads.title": "Gesammelte E-Mails ({n})",
    "owner.leads.empty": "Keine E-Mails.",
    "owner.notFound": "Seite nicht gefunden.",
  },
};

export const DEFAULT_LANG = "fi";

// t("answer.submit") -> Finnish by default. Supports {placeholder} interpolation.
export function t(key, params = {}, lang = DEFAULT_LANG) {
  const dict = TRANSLATIONS[lang] || TRANSLATIONS[DEFAULT_LANG];
  let str = dict[key] ?? TRANSLATIONS[DEFAULT_LANG][key] ?? key;
  for (const [k, v] of Object.entries(params)) {
    str = str.replaceAll(`{${k}}`, String(v));
  }
  return str;
}

// Return a stored inflected name form (e.g. Finnish "allative"/"genitive") or null.
// Never build case forms by concatenation — fall back to a case-free phrasing instead.
export function nameForm(nameForms, lang, caseName) {
  const f = nameForms && nameForms[lang];
  const v = f && f[caseName];
  return typeof v === "string" && v.trim() ? v.trim() : null;
}
